"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Submit = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const index_1 = require("./../index");
const Submit = (props) => {
    return (react_1.default.createElement(index_1.Flex, { justify: "flex-end", align: "center", noGrow: true },
        react_1.default.createElement(index_1.Busy, { show: !!props.submitting }),
        react_1.default.createElement(index_1.FlexSpace, null),
        react_1.default.createElement(index_1.Button, { "aria-label": props.label, disabled: !!props.disabled, type: "submit", height: props.height, "data-testid": props.dataTestId }, props.children)));
};
exports.Submit = Submit;
//# sourceMappingURL=Submit.js.map